/* ** TOP SECRET ** */

import Vue from 'vue';
import VueRouter from 'vue-router';

// 如果需要三级页面等 可以直接套用一下这个 router view 做一个过度
// const RouterView = {
//   template: '<router-view />',
// };

Vue.use(VueRouter);

const routes = [
  // 初始页面跳转
  {
    path: '/',
    redirect: '/applictaion',
  },
  {
    path: '/applictaion',
    component: () => import('../views/Application'),
  },
  // 检测报告
  {
    path: '/report',
    component: () => import('../views/report/index.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
